import Cookies from 'js-cookie'
import Config from '@/settings'

const TokenKey = Config.TokenKey

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // setWebsiteToken(token)
  return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
}

export function removeToken() {
  // setWebsiteToken('')
  return Cookies.remove(TokenKey)
}

